"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cardContextDefaultValue: function() {
        return cardContextDefaultValue;
    },
    CardProvider: function() {
        return CardProvider;
    },
    useCardContext_unstable: function() {
        return useCardContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const cardContext = /*#__PURE__*/ _react.createContext(undefined);
const cardContextDefaultValue = {
    selectableA11yProps: {
        referenceId: undefined,
        setReferenceId () {
        /* Noop */ },
        referenceLabel: undefined,
        setReferenceLabel () {
        /* Noop */ }
    }
};
const CardProvider = cardContext.Provider;
const useCardContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(cardContext)) !== null && _React_useContext !== void 0 ? _React_useContext : cardContextDefaultValue;
};
